module.exports = __webpack_public_path__ + "static/img/4-3.7e82c8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/335/4-3.jpg
// module id = CQoj
// module chunks = 0